export const team21 = [{
  "year": 2021,
  "CoreTeam": [
    {
      "Position": "Chairperson",
      "Name": "Ch. Ullas Reddy",
      
      "ImgPath": "chair.png"
    },
    {
      "Position": "Vice Chairperson",
      "Name": "Gundlapalli Charitha",
      
      "ImgPath": "vice_chair.jpeg"
    },
    {
      "Position": "Secretary",
      "Name": "J. Anurag Pola",
      
      "ImgPath": "sceretary.png"
    },
    {
      "Position": "Treasurer",
      "Name": "Arpan Jain",
      
      "ImgPath": "treasurey.jpeg"
    },
    {
      "Position": "Membership Chair",
      "Name": "Varshitha M",
      
      "ImgPath": "membership.jpeg"
    },
    {
      "Position": "Webmaster",
      "Name": "Nikitha Yellur",
      
      "ImgPath": "web master.jpeg"
    }
  ],
  "TeamHeads": [
    {
      "Position": "Social Media Head",
      "Name": "Alekhya Mengani",
      
      "ImgPath": "sm_head.jpeg"
    },
    {
      "Position": "Events & PR Head",
      "Name": "Siddharth Saxena",
      
      "ImgPath": "pr.jpeg"
    },
    {
      "Position": "Technical Head",
      "Name": "Niharika Sirapurapu",
      
      "ImgPath": "technical.jpeg"
    },
    {
      "Position": "Design Team Head",
      "Name": "Nitya Yerraguntla",
      
      "ImgPath": "design.jpeg"
    },
    {
      "Position": "Coding Team Head",
      "Name": "Rajeshwar Rao",
      
      "ImgPath": "coding.jpg"
    }
  ],
  "Volunteers": [
  {
    "Name": "Avinash Batchu",
    "Team": "Social Media",
    "Phone": "9390333167",
    "Mail":"avinashbatchu10@gmail.com"
    
  },
  {
    "Name": "Kodakandla Harshitha",
    "Team": "Social Media",
    "Phone": "7386917939",
    "Mail": "reddyharshitha942@gmail.com"
  },
  {
    "Name": "Sharwani Kusumba",
    "Team": "Social Media",
    "Phone": "9618953075",
    "Mail": "sharwanikusumba08@gmail.com"
  },
  {
    "Name": "Poojitha Bommu",
    "Team": "Events and PR",
    "Phone": "7997129943",
    "Mail": "poojithareddybommu@gmail.com"
  },
   {
    "Name": "Navya Pagadala",
    "Team": "Events and PR",
    "Phone": "9052742220",
    "Mail": "navyapagadala99@gmail.com"
  },
  {
    "Name": "Bhanusree Eesari",
    "Team": "Design",
    "Phone": "6305745015",
    "Mail": "bhanusree6636@gmail.com"
  },
  
  {
    "Name": "Yasaswini Ganji",
    "Team": "Tech and Social Media",
    "Phone": "6302425547",
    "Mail": "yasaswini0918@gmail.com"
  },
  {
    "Name": "Neelima Gundu",
    "Team": "Technical and Design",
    "Phone": "9014425327",
    "Mail": "neelimagundu02@gmail.com"
  },
  
  
  {
    "Name": "Venkat Nippun",
    "Team": "Events and PR, Social Media",
    "Phone": "8712798597",
    "Mail": "nippun1116@gmail.com"
  },
  {
    "Name": "Teja Abhinav Reddy Kaipu",
    "Team": "Events & PR, Design Teams",
    "Phone": "8886762003",
    "Mail": "tejaabhinavreddykaipu@gmail.com"
  },
  {
    "Name": "Vyooha Bathini",
    "Team": "Events and PR and Design",
    "Phone": "9390493062",
    "Mail": "bathinivyooha24@gmail.com"
  },
  {
    "Name": "Mahesh Varma",
    "Team": "Technical",
    "Phone": "9143859999",
    "Mail": "k.maheshvarma123@gmail.com"
  },
  {
    "Name": "Vysyaraju Harveni",
    "Team": "Technical",
    "Phone": "9440377304",
    "Mail": "vysyarajuharveni1107@gmail.com"
  },
  {
    "Name": "Akhil Nalla",
    "Team": "Technical",
    "Phone": "7995466305",
    "Mail": "akhilnalla62@gmail.com"
  },
  
  {
    "Name": "Sathwika Chittoori",
    "Team": "Technical",
    "Phone": "9390129559",
    "Mail": "sathusweaty@gmail.com"
  },
  {
    "Name": "Prashansa Mishra",
    "Team": "Technical",
    "Phone": "9640614649",
    "Mail": "prashansa2501@gmail.com"
  },
  {
    "Name": "Sai Neha Ch",
    "Team": "Technical",
    "Phone": "9949933880",
    "Mail": "23nehachekuri@gmail.com"
  },
  {
    "Name": "Rahul Chowdary",
    "Team": "Technical",
    "Phone": "9676124421",
    "Mail": "chowdaryrahul1704@gmail.com"
  },

  
  ]
}
]